import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import LaunchIcon from '@mui/icons-material/Launch'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import StyledTable from '@components/StyledTable'
import type { SearchResults } from '@models/SearchResults'

import type { Opdracht } from '../../../opdracht/types/Opdracht'
import { useCombiOpdrachtenSearchStore } from '../../../opdrachten/combi/hooks/useCombiOpdrachtenSearchStore'
import { initialState as initialStateCombiOpdrachten } from '../../../opdrachten/combi/services/searchCombiOpdrachten'
import { useNavigate } from '../../../router/hooks/useNavigate'
import { PageSection } from '../../../theme/components/PageSection'
import { StyledIconButton } from '../../../theme/components/StyledIconButton'

import { OpdrachtenTableRow } from './OpdrachtenTableRow'

const headerCells = [
  { id: 'kpi', numeric: false, label: '', sort: false },
  { id: 'opdrachtId', numeric: true, label: 'Opdracht id', sort: false },
  { id: 'realisatiedatum', label: 'Plandatum', sort: false },
  { id: 'discipline', label: 'Discipline', sort: false, fixed: 50 },
  { id: 'adres', numeric: false, label: 'Adres', sort: false },
  { id: 'netbeheerder', numeric: true, label: 'Netbeheerder', sort: false },
  { id: 'aannemer', numeric: true, label: 'Uitvoerende', sort: false },
  {
    id: 'statusText',
    numeric: false,
    label: 'Status',
    sort: false,
    fixed: 150,
  },
  { id: 'created', label: 'Aangemaakt', sort: false },
  { id: 'changed', label: 'Mutatiedatum', sort: false },
  { id: 'details', label: 'Details', sort: false, fixed: 50 },
]

interface Props {
  opdrachten: SearchResults<Opdracht>
  onChangePage: any
  isLoading: boolean
  aanvraagID: string
}

export const Opdrachten = ({
  opdrachten,
  onChangePage,
  isLoading,
  aanvraagID,
}: Props) => {
  const navigate = useNavigate()
  const { storeQuery: storeQueryCombiOpdrachten } =
    useCombiOpdrachtenSearchStore()

  const { items, count, skip, limit } = opdrachten

  const onNavigateToOpdrachten = ({ aanvraagID }) => {
    storeQueryCombiOpdrachten({
      filters: {
        ...initialStateCombiOpdrachten.query.filters,
        search: aanvraagID,
      },
      sort: initialStateCombiOpdrachten.query.sort,
      page: initialStateCombiOpdrachten.query.page,
    })
    navigate('/combiopdrachten')
  }

  return (
    <PageSection
      heading="Opdrachten"
      id="opdrachten"
      actions={
        <StyledIconButton
          onClick={() => onNavigateToOpdrachten({ aanvraagID })}
          title="Bekijk opdrachten in overzicht"
          icon={<LaunchIcon />}
        />
      }
    >
      <Box>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Alle opdrachten ({count})</Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ padding: 0 }}>
            <StyledTable
              variant="details"
              onChangePage={onChangePage}
              headerCells={headerCells}
              stats={{ count, skip, limit }}
              loading={isLoading}
              sort={{}}
              {...({} as any)}
            >
              {items.map((opdracht) => {
                return (
                  <OpdrachtenTableRow
                    key={opdracht.opdrachtId}
                    opdracht={opdracht}
                  />
                )
              })}
            </StyledTable>
          </AccordionDetails>
        </Accordion>
      </Box>
    </PageSection>
  )
}
